import { CustomerInfoKeyType } from './customer';

export type FormCheckType = '0' | '1';
export type FormCheckNumberType = 0 | 1;

export enum RegisterTypeEnum {
    PHONE = 'phone',
    EMAIL = 'email'
}

// 配置表单项的类型
export interface FieldOption<T = CustomerInfoKeyType> {
    name: T;
    required: boolean;
}

// 国家列表接口数据项类型
export interface CountryItem {
    country_code: string; // 国家码
    country: string; // 国家名称
    tel_code: string;
    pinyin?: string;
    country_name?: string;
    country_en?: string;
    tax_incentives?: boolean;
    country_code2?: string;
}
export interface CountryData {
    items: CountryItem[];
    letter: string;
}

export enum CountryTypeEnum {
    /** 全量国家列表 */
    ALL_COUNTRY = 'country',
    /** 授信联系人 */
    TRUSTED_CONTACT_PERSON = 'trusted_contact_person',
    SSN = 'country_ssn',
    NON_SSN = 'country_non_ssn',
    /** 非SSN国籍 */
    NON_SSN_CITIZENSHIP = 'country_non_ssn_citizenship',
    /** 非SSN邮寄地址国家 */
    NON_SSN_MAILING = 'country_non_ssn_mailing'
}

// 上传证明类型枚举
export enum PicProofEnum {
    // 身份证
    PIC_ID_CARD = 'pic_id_card',
    // 身份证反面
    PIC_ID_OTHER = 'pic_id_other',
    PIC_ID_CARD2 = 'pic_id_card2',
    PIC_ID_OTHER2 = 'pic_id_other2',
    PIC_PASSPORT = 'pic_passport',
    // 居住证明
    PIC_RESIDENCE = 'pic_residence',
    PIC_RESIDENCE_OTHER = 'pic_residence_other',
    // 豁免证明文件
    PIC_EXEMPTION = 'pic_exemption',
    INQUIRY = 'inquiry', //  合规问询文件
    PIC_BIRTH = 'pic_birth'
}

// OCR类型枚举
export enum OCRTypeEnum {
    ID_CARD = 'id_card',
    BANK_CARD = 'bank_card'
}

export enum IdTypeInfoCategoryEnum {
    // 第一证件
    ID_TYPE = 'id_type'
}

// 获取协议的时候对应的协议项的类型
export interface AgreementItemType {
    id: number;
    link_code: string;
    title: string;
}

// 上传路径类型
export type UploadPathType = 'confirm';

// 埋点时所需要的事件属性类型
// ps: 并不是所有属性都是埋点所需, 埋点所需具体字段可以参考trackStore.trackEvent
export interface EventParams {
    name: string;
    model: string;
    openType?: 'ssn' | 'no_ssn' | 'ira'; // 产品观察的开户类型的值, 对应埋点系统中的param1 @黄鑫
    eventBaseInfoType?: string; // 对应埋点字段 param2
}
